// filepath: apps/web/src/editors/form-builder/FormFieldPalette.tsx
//
// FR-UI-BLD-1 AC-1 — left-hand field palette. 10 canonical field
// types (FR-FORM-1). Each tile is a drag source (`fieldType`).
//
// The drag handle is rendered via HTML5 drag-and-drop (compatible
// with dnd-kit when added) — the field type is carried in the
// dataTransfer payload.

import React from "react";
import { useTranslation } from "react-i18next";
import { ALL_FIELD_TYPES, type FieldType } from "./types";

interface FormFieldPaletteProps {
  onDragFieldType: (fieldType: FieldType) => void;
}

export function FormFieldPalette({
  onDragFieldType,
}: FormFieldPaletteProps): React.ReactElement {
  const { t } = useTranslation();
  return (
    <aside
      className="form-field-palette"
      aria-label={t("admin.builder.palette.aria")}
      data-testid="form-field-palette"
    >
      <h2 className="form-field-palette__title">
        {t("admin.builder.palette.title")}
      </h2>
      <ul className="form-field-palette__list">
        {ALL_FIELD_TYPES.map((ft) => (
          <li
            key={ft}
            className="form-field-palette__item"
            draggable
            onDragStart={(e) => {
              e.dataTransfer.setData("fieldType", ft);
              onDragFieldType(ft);
            }}
            data-testid={`palette-item-${ft}`}
            data-field-type={ft}
          >
            {t(`admin.builder.field_types.${ft}`)}
          </li>
        ))}
      </ul>
    </aside>
  );
}
